module.exports = __webpack_public_path__ + "img/bg2.a6d26dd1.png";